import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import MarketingLayout from "@/components/MarketingLayout";
import DashboardLayout from "@/components/DashboardLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/marketing/Home";
import Features from "@/pages/marketing/Features";
import Pricing from "@/pages/marketing/Pricing";
import About from "@/pages/marketing/About";
import FAQ from "@/pages/marketing/FAQ";
import Contact from "@/pages/marketing/Contact";
import Terms from "@/pages/marketing/Terms";
import Privacy from "@/pages/marketing/Privacy";
import Blog from "@/pages/marketing/Blog";
import BlogPost from "@/pages/marketing/BlogPost";
import ToolsHub from "@/pages/marketing/ToolsHub";
import RankChecker from "@/pages/tools/RankChecker";
import SerpPreview from "@/pages/tools/SerpPreview";
// eslint-disable-next-line no-unused-vars
import MetaChecker from "@/pages/tools/MetaChecker";
import Login from "@/pages/auth/Login";
import Signup from "@/pages/auth/Signup";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import Overview from "@/pages/dashboard/Overview";
import Projects from "@/pages/dashboard/Projects";
import ProjectDetail from "@/pages/dashboard/ProjectDetail";
// eslint-disable-next-line no-unused-vars
import WhatsChangedGlobal from "@/pages/dashboard/WhatsChangedGlobal";
// eslint-disable-next-line no-unused-vars
import AiAnalysisPage from "@/pages/dashboard/AiAnalysisPage";
import SettingsPage from "@/pages/dashboard/SettingsPage";
import AlertsPage from "@/pages/dashboard/AlertsPage";
import ReportsPage from "@/pages/dashboard/ReportsPage";
import OpportunityPage from "@/pages/dashboard/OpportunityPage";
import BrandSettingsPage from "@/pages/dashboard/BrandSettingsPage";
import SeoSettingsPage from "@/pages/dashboard/SeoSettingsPage";
import CmsPage from "@/pages/dashboard/CmsPage";
import AdminPage from "@/pages/dashboard/AdminPage";
import TeamPage from "@/pages/dashboard/TeamPage";
import SharedView from "@/pages/SharedView";
import JoinPage from "@/pages/JoinPage";

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
        <Routes>
          <Route element={<MarketingLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/tools" element={<ToolsHub />} />
            <Route path="/tools/rank-checker" element={<RankChecker />} />
            <Route path="/tools/serp-preview" element={<SerpPreview />} />
            {/* Temporarily hidden — Meta Title & Description Checker is being rebuilt. */}
            {/* <Route path="/tools/meta-checker" element={<MetaChecker />} /> */}
            <Route path="/tools/meta-checker" element={<Navigate to="/tools" replace />} />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/share/:token" element={<SharedView />} />
          <Route path="/join/:token" element={<JoinPage />} />

          <Route path="/app" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<Overview />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:id" element={<ProjectDetail />} />
            {/* Temporarily hidden — "What's changed" is being redesigned. */}
            {/* <Route path="changes" element={<WhatsChangedGlobal />} /> */}
            <Route path="changes" element={<Navigate to="/app/overview" replace />} />
            <Route path="opportunity" element={<OpportunityPage />} />
            <Route path="alerts" element={<AlertsPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="branding" element={<BrandSettingsPage />} />
            <Route path="seo" element={<SeoSettingsPage />} />
            <Route path="cms" element={<CmsPage />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="team" element={<TeamPage />} />
            {/* Temporarily hidden — AI analysis is being redesigned. */}
            {/* <Route path="ai" element={<AiAnalysisPage />} /> */}
            <Route path="ai" element={<Navigate to="/app/overview" replace />} />
            <Route path="tools" element={<ToolsHub embedded />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}
